import React from 'react';
import MaterialDivider from '@material-ui/core/Divider';

import { useWidth, } from 'common/hooks';

const mobileScreenSize = [ 'xs', ];

const Divider = () => {
    const actualScreenSize = useWidth();

    const orientation = mobileScreenSize.includes(actualScreenSize) ? 'horizontal' : 'vertical';

    return (
        <MaterialDivider orientation={orientation} />
    );
};

export default Divider;
